'use client'

import { IconBoxItemProps } from 'components/IconBox'
import dynamic from 'next/dynamic'

import { RenderOnScroll } from '@/components/RenderOnScroll'

const DynamicBenefitsList = dynamic(() =>
	import('./BenefitsListItem').then((mod) => mod.BenefitsListItem),
)

export const LazyBenefitList = (props: { items: IconBoxItemProps[] }) => (
	<RenderOnScroll element={<DynamicBenefitsList {...props} />} />
)
